// extracted by mini-css-extract-plugin
export default {"menuBtn":"UserInfoMenu_menuBtn__KUnne"};